const getLatLngLiteral = ({ lat, lon, lng }) => ({
  lat: parseFloat(lat),
  lng: parseFloat(lon || lng)
})

export default getLatLngLiteral
